import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'checkbox',
    'toggleAll',
    'selectedCount',
    'allocationCount',
    'monthCount',
    'excludedCount',
    'submit',
    'warning'
  ]

  static values = { minimum: Number, automaticExclusions: Number, indexUrl: String }

  connect () {
    this.update()
  }

  toggleAll () {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = this.toggleAllTarget.checked })
    this.update()
  }

  prepareHistory () {
    window.history.replaceState(window.history.state, '', this.indexUrlValue)
  }

  update () {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked)
    const selectedCount = selected.length

    this.toggleAllTarget.checked = selectedCount === this.checkboxTargets.length
    this.toggleAllTarget.indeterminate = selectedCount > 0 && selectedCount < this.checkboxTargets.length
    this.selectedCountTargets.forEach((target) => { target.textContent = selectedCount.toString() })
    this.allocationCountTarget.textContent = selected.reduce((total, checkbox) => total + Number(checkbox.dataset.allocationCount ?? '0'), 0).toString()
    this.monthCountTarget.textContent = new Set(selected.map((checkbox) => checkbox.dataset.month)).size.toString()
    this.excludedCountTarget.textContent = (this.automaticExclusionsValue + this.checkboxTargets.length - selectedCount).toString()
    this.submitTarget.disabled = selectedCount < this.minimumValue
    this.warningTarget.hidden = selectedCount >= this.minimumValue

    this.checkboxTargets.forEach((checkbox) => {
      const row = checkbox.closest('tr')
      const status = row?.querySelector('.year-end-selection-status')
      row?.classList.toggle('is-excluded', !checkbox.checked)
      status?.classList.toggle('is-excluded', !checkbox.checked)
      if (status != null) status.innerHTML = checkbox.checked ? '<i aria-hidden="true">✓</i> Included' : '<i aria-hidden="true">−</i> Excluded'
    })
  }
}
